// extracted by mini-css-extract-plugin
export var emptyText = "search-result-list-module--emptyText--a6eaf";
export var emptyView = "search-result-list-module--emptyView--d86d9";
export var list = "search-result-list-module--list--36b44";
export var listItem = "search-result-list-module--listItem--00eea";